import React from 'react';
import { Brain, Zap, Sparkles } from 'lucide-react';

interface AIGeneratorCTAProps {
  childName: string;
  onSingleActivity: () => void;
  onBatchWizard: () => void;
}

export function AIGeneratorCTA({ childName, onSingleActivity, onBatchWizard }: AIGeneratorCTAProps) {
  return (
    <div className="bg-gradient-to-r from-purple-500 via-blue-500 to-indigo-600 rounded-2xl p-8 text-white">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-2xl font-bold mb-2">AI Activity Generator</h3>
          <p className="text-purple-100 mb-4">
            Create personalized learning activities for {childName} using AI
          </p>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="bg-white bg-opacity-10 rounded-lg p-4">
              <h4 className="font-semibold mb-1">Single Activity</h4>
              <p className="text-sm text-purple-100 opacity-90">Generate one activity at a time</p>
            </div>
            <div className="bg-white bg-opacity-10 rounded-lg p-4">
              <h4 className="font-semibold mb-1">Batch Generation</h4>
              <p className="text-sm text-purple-100 opacity-90">Create multiple activities at once</p>
            </div>
          </div>
        </div>
        <div className="flex flex-col space-y-3">
          <button
            onClick={onBatchWizard}
            className="flex items-center space-x-2 px-6 py-3 bg-white text-purple-600 rounded-xl hover:bg-gray-100 transition-colors font-semibold"
          >
            <Zap className="w-5 h-5" />
            <span>Batch Wizard</span>
            <Sparkles className="w-4 h-4" />
          </button>
          <button
            onClick={onSingleActivity}
            className="flex items-center space-x-2 px-6 py-3 bg-purple-600 border-2 border-white text-white rounded-xl hover:bg-purple-700 transition-colors font-semibold"
          >
            <Brain className="w-5 h-5" />
            <span>Single Activity</span>
          </button>
        </div>
      </div>
    </div>
  );
}
